import styled from 'styled-components/macro'
import checkmark from '../../../assets/images/checkmark.svg'

interface ErrorWrapperProps {
  $hasError?: boolean
}

export const CheckboxContainer = styled.div`
  width: 100%;
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;

  &.white {
    label {
      color: white;
    }

    input {
      border: 1px solid white;
    }

    input.checked::before {
      filter: brightness(0) invert(1);
    }
  }

  &.error {
    input {
      border: 1px solid #ff0000;
    }
  }
`

export const InnerContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
`

export const ErrorWrapper = styled.div<ErrorWrapperProps>`
  width: 100%;
`

export const InputWrapper = styled.div`
  flex-shrink: 0;
  margin-top: 4px;
`

export const Label = styled.label`
  font-weight: 400;
  font-size: 18px;
  line-height: 1.5;
  letter-spacing: -0.025em;
  color: #000000;
  margin-right: 10px;
  flex: 1;
  cursor: pointer;

  a {
    text-decoration: underline;
    color: inherit;
    font-weight: inherit;
  }
`

export const Input = styled.input`
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 2px;
  border: 1px solid #000000;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &.checked {
    position: relative;
    &::before {
      content: '';
      background: url(${checkmark});
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      width: 18px;
      height: 18px;
    }
  }
`
